import { Injectable, OnInit } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { PixQrCodeDynamicService } from '../../copy-and-paste/qr-code-dynamic/qr-code-dynamic.service';
import { PixPaymentKeyService } from '../../payment-key/payment-key.service';

@Injectable()
export class WithdrawChangeGuard implements CanActivate{

	constructor(
		private router: Router,
		private pixQrCodeDynamicService: PixQrCodeDynamicService,
		private pixPaymentKeyService: PixPaymentKeyService){}

		canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
			const pixQrCodeDynamicReturn = this.pixQrCodeDynamicService.getSelectedPixQrCodeReturn();
			const pixQrCodeStaticReturn = this.pixPaymentKeyService.getSelectedPixPaymentFavoredView();

			if (!pixQrCodeDynamicReturn && !pixQrCodeStaticReturn) {
				this.router.navigate(['pix']);
				return false;
			}

			return true;
		}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/withdraw-change/guard/withdraw-change.guard.ts